const translation = {
  daysInWeek: {
    Tue: 'Martedì',
    Thu: 'Giovedì',
    Mon: 'Mon',
    Fri: 'Venerdì',
    Sat: 'Sat',
    Wed: 'Mercoledì',
    Sun: 'Sole',
  },
  months: {
    February: 'Febbraio',
    April: 'Aprile',
    January: 'Gennaio',
    December: 'Dicembre',
    March: 'Marzo',
    May: 'Maggio',
    August: 'Agosto',
    June: 'Giugno',
    July: 'Luglio',
    October: 'Ottobre',
    September: 'Settembre',
    November: 'Novembre',
  },
  operation: {
    ok: 'OK',
    now: 'Ora',
    cancel: 'Annulla',
    pickDate: 'Seleziona Data',
  },
  title: {
    pickTime: 'Scegli Tempo',
  },
  defaultPlaceholder: 'Scegli un orario...',
}

export default translation
